import { styled } from 'styled-components';
import { keyframeRotate } from '../styles/keyframes.js';

type FuuzeLoadingProps = {
  $color?: 'dark' | 'light' | 'orange';
  $size?: number;
  $strokeWidth?: number;
  $bgColor?: string;
};

export const FuuzeLoading = styled.div<FuuzeLoadingProps>`
  --color: ${({ $color, theme }) => {
    let color = theme.colors.dark.dark100;
    if ($color === 'light') color = theme.colors.white;
    if ($color === 'orange') color = theme.colors.orange.orange80;
    return color;
  }};

  --bg-color: ${props => props.$bgColor || props.theme.colors.dark.dark200};
  --size: ${props => props.$size || 20}px;
  --stroke-width: ${props => props.$strokeWidth || 2}px;

  height: var(--size);
  width: var(--size);
  animation: ${keyframeRotate(0, 359)} 1s infinite linear;
  border: var(--stroke-width) solid var(--bg-color);
  border-radius: 100%;

  &:before {
    content: "";
    display: block;
    position: absolute;
    left: calc(var(--stroke-width) * -1);
    top: calc(var(--stroke-width) * -1);
    height: 100%;
    width: 100%;
    border-top: var(--stroke-width) solid var(--color);
    border-left: var(--stroke-width) solid transparent;
    border-bottom: var(--stroke-width) solid transparent;
    border-right: var(--stroke-width) solid transparent;
    border-radius: 100%;
  }
`;
